import { Component, Vue} from 'vue-property-decorator';
import { ERRORS_METRICS } from './columns'

@Component
export default class ErrorsMetricsMixin extends Vue {
  get errorsMetrics()  {
    return{
      order: ERRORS_METRICS.order,
      avaliable_metrics: ERRORS_METRICS.allColumns,
      default_omit: ERRORS_METRICS.defaultUnselected,
      default_include: ERRORS_METRICS.defaultSelected,
      default_sort: ERRORS_METRICS.defaultSort,
      metrics_help: {
        'errors-timestamp': {
          short: this.t('Date and time of error'),
          full: this.t('Date and time of error will be displayed according to your timezone settings in tracker.')
        },
        'errors-campaignname': {
          short: this.t('Campaign name'),
          full: this.t('Custom name of campaign connected with the error.')
        },
        'errors-campaignid': {
          short: this.t('ID of campaign'),
          full: this.t('Unique ID of campaign associated with error.')
        },
        'errors-category': {
          short: this.t('Type of error'),
          full: this.t('The error can be connected with the following categories: postback, redirect, click.')
        },
        'errors-message': {
          short: this.t('Description of error'),
          full: this.t('Detailed description of the errors that occur in particular campaign.')
        },
        'errors-url': {
          short: this.t('URL associated with the error'),
          full: this.t('Link  of the campaign, landing page, postback or click URL related to error.')
        },
        'errors-referer': {
          short: this.t('Referrer data'),
          full: this.t('Referrer data associated with error.')
        },
        'errors-useragent': {
          short: this.t('User agent data'),
          full: this.t('User agent data related to error.')
        },
        'errors-ip': {
          short: this.t('IP address data'),
          full: this.t('IP address associated with error.')
        },
      },
      metrics_options: ERRORS_METRICS.weight,
      sort_exclude: ERRORS_METRICS.sortExclude
    } as Bemob.Metrics
  }
}
